/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StopFilledIcon = /*#__PURE__*/ createSvgIcon(
  'StopFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.5 12.999V6.994c0-.413.147-.765.441-1.056a1.451 1.451 0 011.06-.438h6.005c.413 0 .765.147 1.056.441.292.294.438.647.438 1.06v6.005c0 .413-.147.765-.441 1.056a1.45 1.45 0 01-1.06.438H6.994c-.413 0-.765-.147-1.056-.441a1.451 1.451 0 01-.438-1.06z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default StopFilledIcon;
